import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik , Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Container } from 'semantic-ui-react';
import  * as yup from 'yup';
import moment from 'moment';
import Axios from 'axios';

import AddTitleBar from '../../components/titleBar/addTitleBar';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import APP_CONSTANTS from '../../config/constants';


//Inputs
import { DateData } from '../formikInput/date';
import UploadFile from '../formikInput/fileUpload';

//Add-Product
import AddProduct from '../purchaseOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder'

//Dropdowns
import PurchaseOrderVendorDropdown from '../dropdowns/purchaseOrderVendorDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import VendorVehicleDropdown from '../dropdowns/vendorVehicleDropdown';

//Actions 
import { getBills, updateBill } from '../../redux/actions/billActions';
import { getVendorPurchaseOrderPo, getVendorPurchaseOrder, getMappedVendorPurchaseOrder } from '../../redux/actions/purchaseOrderActions';
import SupportingDoc from './supportingDoc';
import { MyTextArea } from '../formikInput/input';
import { fields, titles } from './bill.constants';
import { DATE_FORMATS } from '../../config/const';
import CheckedPurchaseOrder from './checkedPurchaseOrder';


const ViewBill = (props) => {

    const { getBills,
         updateBill,
         getVendorPurchaseOrder, 
         getVendorPurchaseOrderPo, 
         vendorPurchaseOrderData, 
         vendorPurchaseOrderLoading, 
         vendorPurchaseOrderPagination,
         billData, 
         billLoading } = props;

    //State
    const [activateManualPO, setActivateManualPO] = useState(false);
    const [vehicleData, setVehicleData] = useState([]); 
    const [supportDocArray, setSupportDocArray] = useState([]);
    const [mappedSoArray, setMappedSoArray] = useState([])
    const [purchaseOrderCurrentPage, setPurchaseOrderCurrentPage] = useState(1);
    const [mappedPurchaseOrderCurrentPage, setMappedPurchaseOrderCurrentPage] = useState(1);
    const [mappedPOPagination, setMappedPOPagination] = useState()
    const [editMappedPOLoading, setEditMappedPOLoading] = useState(false);
    const [editLoading, setEditLoading] = useState(false);

    //UseEffect
    useEffect(() => {
        const billRefNo = props.location.state.id
        const billId = props.location.state.billId
        const edit = true

        const vendorData = {
            vendorCode: props.location.state.vendorCode,
            billId: billId
        }

        getBills(billRefNo,props.location.state.billId);
        getVendorPurchaseOrder(vendorData, vendorData.vendorCode, 1, '', edit, true);
        setEditMappedPOLoading(true)
        getMappedVendorPurchaseOrder(vendorData, vendorData.vendorCode, 1, "", '', true, vendorData.billId).then(
            (res) => {
                setEditMappedPOLoading(false)
                setMappedSoArray(res.data)
                setMappedPOPagination(res.pagination)
            }
        );
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        
        let supportBillData = JSON.stringify
        ({
            "customerNumber": customerNo,
            "userId": userId,
            "customer_no": customerNo,
            "user_id": userId,
            "customerNo": customerNo,
            "billId": vendorData.billId.toString()
        })

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getBillSupportingDocumentType`, supportBillData,  {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setSupportDocArray(response.data.data);
        }))
            .catch(error => console.log(error));


    }, [getBills])

    const handlePaginationChange = (activePage) => {
        setPurchaseOrderCurrentPage(activePage);
        getPoData(activePage);
      };

      const getPoData = (activePage, searchString) => {
        setEditLoading(true);
        const edit = true;
        const vendorData = {
          vendorCode: props.location.state.vendorCode,
          billId: props.location.state.billId,
        };
    
        getVendorPurchaseOrder(
          vendorData,
          vendorData.vendorCode,
          activePage,
          searchString,
          edit,
          true
        ).then(() => {
          setEditLoading(false);
        });
      };

      const handleMappedPOPaginationChange = (activePage) => {
        setMappedPurchaseOrderCurrentPage(activePage);
        getMappedPoData(activePage);
      };
      const getMappedPoData = (activePage, searchString) => {
        setEditMappedPOLoading(true)
        const edit = true;
        const vendorData = {
          vendorCode: props.location.state.vendorCode,
          billId: props.location.state.billId,
        };
    
      getMappedVendorPurchaseOrder(vendorData, vendorData.vendorCode, activePage, "", '', true,vendorData.billId).then(
          (res) => {
            setEditMappedPOLoading(false)
            setMappedSoArray(res.data)
            setMappedPOPagination(res.pagination)
          }
        );
      };

            let activePOData = [];
            vendorPurchaseOrderData && vendorPurchaseOrderData.map((o,i) => {
                let temp = {}

                function containsPoId(obj, list) {
                    var i;
                    for (i = 0; i < list?.length; i++) {
                        if (list[i].poId === obj.poId) {
                            return true;
                        }
                    }
                
                    return false;
                }

                temp.checkbox = billData && billData[0]?.bill_po_mapping ?  containsPoId(o, billData[0]?.bill_po_mapping) : ''
                temp.poId = o.poId
                temp.poReferenceNo = o.poReferenceNo
                temp.vendorCode = o.vendorId
                temp.orderNo = o.orderNo;
                temp.branchCode = o.branchId   
                temp.vehicleNo = o.vehicleId
                temp.poQuantity = o.poQuantity
                temp.poAmount = o.poAmount
                temp.poNumber = o.poNumber
                temp.expectedDeliveryDate = o.expectedDeliveryDate ? o.expectedDeliveryDate : ''
                temp.sgstAmount = o.sgstAmount
                temp.cgstAmount = o.cgstAmount
                temp.igstAmount = o.igstAmount
                temp.adjustment = o.adjustment
                temp.totalOrderAmt = o.totalOrderAmt
                temp.remarks = o.remarks
                temp.gstTaxType = o.gstTaxType
                temp.poDate = o.poDate
                temp.tdsAmount = o.tdsAmount
                temp.taxableAmount = o.taxableAmount
                temp.totalDiscount = o.totalDiscount

                activePOData[i] = temp
            })

            let mappedPOData = [];

            mappedSoArray &&      
              mappedSoArray.map((o, i) => {
                let temp = {};
        
                function containsPoId(obj, list) {
                  var i;
                  for (i = 0; i < list.length; i++) {
                    if (list[i].poId === obj.poId) {
                      return true;
                    }
                  }
        
                  return false;
                }
        
                temp.checkbox = billData && billData[0]?.bill_po_mapping ? containsPoId(o, billData[0]?.bill_po_mapping):'';
                temp.isEditable = billData && billData[0]?.bill_po_mapping ? containsPoId(o, billData[0]?.bill_po_mapping) :'';
                temp.poId = o.poId;
                temp.poReferenceNo = o.poReferenceNo;
                temp.vendorCode = o.vendorId;
                temp.orderNo = o.orderNo;
                temp.branchCode = o.branchId;
                temp.vehicleNo = o.vehicleId;
                temp.poQuantity = o.poQuantity;
                temp.poAmount = o.poAmount;
                temp.poNumber = o.poNumber;
                temp.expectedDeliveryDate = o.expectedDeliveryDate
                  ? o.expectedDeliveryDate
                  : "";
                temp.sgstAmount = o.sgstAmount;
                temp.cgstAmount = o.cgstAmount;
                temp.igstAmount = o.igstAmount;
                temp.adjustment = o.adjustment;
                temp.totalOrderAmt = o.totalOrderAmt;
                temp.remarks = o.remarks;
                temp.gstTaxType = o.gstTaxType;
                temp.poDate = o.poDate;
                temp.tdsAmount = o.tdsAmount;
                temp.taxableAmount = o.taxableAmount;
                temp.totalDiscount = o.totalDiscount;
        
                mappedPOData[i] = temp;
              });

            let tempDocArray = [];
            supportDocArray && supportDocArray.map((doc, docIndex) => {
                let temp = {};
                temp.billId = doc.billId
                temp.supportingDocumentTypeName = doc.supportingDocumentTypeName
                temp.supportingDocumentTypeId = doc.supportingDocumentTypeId
                temp.fileUrl = ""
                temp.fileDownload = doc.fileUrl
                temp.isDeleted = doc.isDeleted
                temp.billSupportingDocumentTypeMappingId = doc.billSupportingDocumentTypeMappingId

                return tempDocArray[docIndex] = temp
            })

            //Formik
            const initialValues = {
                glCode: billData ? billData[0].GLCode : '',
                vendorId: billData ? billData[0].vendorId : "",
                vendorName: billData ? billData[0].vendorName : '',
                billNumber: billData ? billData[0].billNo : '',
                billDate: billData ? new Date(billData[0].billDate) : '',
                expectedPaymentDate: billData ? new Date(billData[0].expectedPaymentDate) : '',
                branch: billData ? billData[0].branchCode : '',
                remarks: billData ? billData[0].remarks: "",
                billReferenceNo: billData ? billData[0].billReferenceNo : '',
                billReceiptDate: billData && billData[0].billReceiptDate !== "01-01-1970" ? new Date(billData[0].billReceiptDate) : '',
                supportDoc: tempDocArray || [{
                    supportingDocumentTypeId : "0",
                    supportingDocumentTypeName : "",
                    fileUrl : "",
                    billId: "0"
                }],
                productDetails: [{
                    productName: '',
                    startDate: '',
                    endDate: '',
                    quantity: 1,
                    rate: '',
                    discount: '',
                    discountType: "1",
                    iGstPercent: 0, 
                    iGst: 0,
                    cGstPercent: 0, 
                    cGst: 0,
                    sGstPercent: 0, 
                    sGst: 0,
                    amount: 0,
                }],
                activePODetails: activePOData,
                mappedPODetails:mappedPOData,
                finalAmount: '',
                mappedPOFinalAmount:'',
                activePOSelected: [],
                isGstApplicable: billData && billData[0].isGstApplicable === 0 ? false : true,
            }

            const validateSchema = yup.object().shape({
                vendorName: yup.mixed().required('Partner Name is Required'),
                billDate: yup.mixed().required('Bill Date is Required'),
                branch: yup.mixed().required('Branch is Required'),
                expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
                billReferenceNo: yup.mixed().required('Bill Reference Number is Required'),
            })

            const onSubmit = (values, onSubmitProps) => {
                const customerNumber = localStorage.getItem('customerNo');
                const userId = localStorage.getItem('userId');

                let psLineItems = [];
                values.productDetails.map((product, index) => {
                    let temp = {}
                    temp.psCode = product.productCode
                    temp.psName = product.productName
                    temp.startDate = product.startDate
                    temp.endDate = product.endDate
                    temp.psQty = product.quantity
                    temp.psPrice = product.rate
                    temp.psAmount = product.rate * product.quantity
                    temp.igstPercent = product.iGstPercent
                    temp.igstAmount = product.iGst
                    temp.cgstPercent = product.cGstPercent
                    temp.cgstAmount = product.cGst
                    temp.sgstPercent = product.sGstPercent
                    temp.sgstAmount = product.sGst
                    temp.tdsCode = 9
                    temp.discount = product.discount
                    temp.finalDiscount = product.discount
                    temp.discountType = product.discountType
                    temp.taxableAmount = product.rate * product.quantity
                    psLineItems[index] = temp
                });

                let exLineItems = [];
                values.activePOSelected.map((product, index) => {
                    let temp = {}
                    temp.poReferenceNo = product.poReferenceNo
                    exLineItems[index] = temp
                })

                let manualPoArray = [
                    {
                        poReferenceNo: values.poReferenceNo,
                        vendorCode: values.vendorName,
                        branchCode: values.vendorBranch,
                        vehicleNo: values.vehicleNumber,
                        poQuantity: psLineItems.length,
                        poAmount: values.finalAmount,
                        sgstAmount: 0,
                        cgstAmount: 0,
                        igstAmount: 0,
                        adjustment: 0,
                        totalOrderAmt: values.finalAmount,
                        remarks: '',
                        gstTaxType: 0,
                        poDate: new Date(),
                        tdsAmount: 0,
                        taxableAmount: values.finalAmount,
                        totalDiscount: 0,
                        psDetails: psLineItems
                    }  
                ]

                if(activateManualPO){
                    exLineItems = [];
                } else {
                    manualPoArray = [];
                }

                const updateBillData = {
                    customerNo: customerNumber,
                    userId: userId,
                    vendorCode: billData[0].vendorCode,
                    billAmount: values.finalAmount,
                    statusCode: '',
                    expectedPaymentDate: moment(values.expectedPaymentDate).format("DD-MM-YYYY"),
                    billReferenceNo: values.billReferenceNo,
                    billDate: moment(values.billDate).format("DD-MM-YYYY"),
                    totalPoAmount: values.finalAmount,
                    termsConditions: '',
                    remarks: '',
                    branchCode: values.branch,
                    gstTaxType: 2,
                    totalTaxableAmount: 0,
                    totalSgstAmount: 2,
                    totalCgstAmount: 2,
                    totalIgstAmount: 2,
                    totalTdsAmount: 2,
                    departMentCategoryCode: 0,
                    irn: '',
                    hsnCode: '',
                    noOfLineItems: psLineItems.length,
                    isPartialBill: 0,
                    grn: '',
                    grnDateTime: '',
                    billReceiptDate: moment(values.billReceiptDate).format("DD-MM-YYYY"),
                    poDate: '',
                    totalOrderAmt: values.finalAmount,
                    adjustment: 0,
                    poAmount: values.amount,
                    poQuantity: 1,
                    tdsAmount: '',
                    taxableAmount: 2,
                    totalDiscount: 0,
                    existingPoArray: exLineItems,
                    manualPoArray: manualPoArray,
                };

                updateBill(updateBillData).then(() => {
                    setTimeout(() => {onSubmitProps.setSubmitting(false)} , 4000)
                });

            };

            const handleDownload = () => {
                window.open(billData[0].filePath)
            }

        return (
            <React.Fragment>
                <AddTitleBar title="View Bill" LinkName="/bill" />
                <div className="m-2">
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => {
                            const { activePODetails, mappedPODetails, productDetails, manualPoAddedTotal } = values

                            let tempPoAmount = []
                            let selectedPO = []
                            let mappedPOAmount = []

                            activePODetails.filter((item) => {                                    
                                if(item.checkbox === true){
                                    if(values.isGstApplicable){
                                        tempPoAmount.push(item.poAmount)
                                        selectedPO.push(item)
                                    } else {
                                        tempPoAmount.push(item.taxableAmount)
                                        selectedPO.push(item)
                                    }                                   
                                }
                            })

                            mappedPODetails.filter((item) => {                                    
                                if(item.checkbox === true){
                                    if(values.isGstApplicable){
                                        mappedPOAmount.push(item.poAmount)
                                        selectedPO.push(item)
                                    } else {
                                        mappedPOAmount.push(item.taxableAmount)
                                        selectedPO.push(item)
                                    }                                   
                                }
                            })

                            values.finalAmount = tempPoAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)                  
                            values.mappedPOFinalAmount = mappedPOAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)                  
                            return (
                                <>
                                    <Segment>
                                        <div className="ui form tiny">                                            
                                            <FormUi.Group >
                                                <FormUi.Field width="4">
                                                    <label className="labelName mt-2">{fields.partnerName.label || "Partner Name"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <div className='mt-2'>{values.vendorName}</div>                                           
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.billNumber.label || "Bill Number"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <Fieldmik name="billNumber" placeholder={fields.billNumber.placeholder || "Bill Number"} readOnly />
                                                    {touched.billNumber && errors.billNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billNumber}</strong> : ''}
                                                </FormUi.Field>     
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="4">
                                                    <label className="labelName mt-2">{fields.billDate.label || "Bill Date"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        readOnly
                                                        name={`billDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat={DATE_FORMATS.ddMMyyyy ||  "dd-MM-yyyy"}
                                                        placeholderText={fields.billDate.placeholder || "Date"}
                                                        selected={values.billDate}
                                                        minDate={new Date()}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input error={values.billDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />  
                                                    {touched.billDate && errors.billDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billDate}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.branch.label || "Branch"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <Fieldmik component={BranchDropdown} disabled name="branch" placeholder={fields.branch.placeholder || "Branch"} value={values.branch} />
                                                    {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="4">
                                                    <label className="labelName mt-2">{fields.expectedPaymentDate.label || "Expected Payment Date"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        readOnly
                                                        name={`expectedPaymentDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat={DATE_FORMATS.ddMMyyyy ||  "dd-MM-yyyy"}
                                                        placeholderText={fields.expectedPaymentDate.placeholder || "Date"}
                                                        selected={values.expectedPaymentDate}
                                                        minDate={values.billDate}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />  
                                                    {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">{fields.billReferenceNumber.label || "Bill Reference Number"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <Fieldmik name="billReferenceNo" readOnly placeholder={fields.billReferenceNumber.placeholder || "Reference Number"} value={values.billReferenceNo} />
                                                    {touched.billReferenceNo && errors.billReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billReferenceNo}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group> 
                                            <FormUi.Group >
                                                <FormUi.Field width="4">
                                                    <label className="labelName mt-2">{fields.billRecieptDate.label || "Bill Receipt Date"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        readOnly
                                                        name={`billReceiptDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat={DATE_FORMATS.ddMMyyyy ||  "dd-MM-yyyy"}
                                                        placeholderText={fields.billRecieptDate.placeholder || "Date"}
                                                        selected={values.billReceiptDate}
                                                        minDate={new Date()}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />  
                                                    {touched.billReceiptDate && errors.billReceiptDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billReceiptDate}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />

                                                <FormUi.Field width="3"> 
                                                    <label className="labelName mt-2">{fields.glCode.label || "GL Code"}</label>
                                                </FormUi.Field>                                                                  
                                                <FormUi.Field width="3">
                                                    <Fieldmik name="glCode" readOnly placeholder={fields.glCode.placeholder || "GL Code"} value={values.glCode} />
                                                    {touched.glCode && errors.glCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.glCode}</strong> : ''}
                                                </FormUi.Field>
                                            
                                                {billData && billData[0].filePath ?
                                                <>
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">{fields.downloadInvoice.label || "Download Invoice"}</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field>
                                                        <Button onClick={handleDownload} type="button" color="blue" icon='download' size="tiny" basic></Button>
    
                                                    </FormUi.Field>
                                                </>
                                                :
                                                ""}
                                            </FormUi.Group>  
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">
                                                        {fields.remarks.label || "Remarks"}
                                                    </label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={MyTextArea} name="remarks" placeholder={fields.remarks.placeholder || "remarks"} />
                                                    {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                        </div>
                                    </Segment>
                                    <Segment compact>
                                        <SupportingDoc viewMode={true}/>     
                                    </Segment>
                                    <Segment>
                                        <div className="ui form">        
                                            <Button 
                                                type="button" 
                                                onClick={() => { setActivateManualPO(false)}}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={!activateManualPO}
                                            >
                                                {titles.activePurchaseOrder || "Active Purchase Order"}
                                            </Button>
                                            {/* <Button 
                                                type="button" 
                                                onClick={() => { setActivateManualPO(true)}}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={activateManualPO}
    
                                            >
                                                New Purchase Order
                                            </Button>
                                            */}
                                            {/* FieldArray Component */}
                                            { activateManualPO ? 
    
                                            <>    
                                            <Container className="m-2">
                                                <FormUi.Group > 
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">{fields.vehicleNumber.label || "Vehicle Number"}</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="3">
                                                        <Fieldmik component={VendorVehicleDropdown} readOnly name="vehicleNumber" placeholder={fields.vehicleNumber.placeholder || "Vehicle Number"} vehicleData={vehicleData} />
                                                        {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                    </FormUi.Field>
                                                    <FormUi.Field width="2" />
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">{fields.poReferenceNumber.label || "PO Reference Number"}</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="3">
                                                        <Fieldmik name="poReferenceNo" readOnly placeholder={fields.poReferenceNumber.placeholder || "Reference Number"} />
                                                        {touched.poReferenceNo && errors.poReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.poReferenceNo}</strong> : ''}
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                            </Container>       
    
                                            <AddProduct /> 
                                                </>
                                                : <>
                                                    {editMappedPOLoading || billLoading ?
                                                        <React.Fragment>
                                                            <LoadingPlaceholder />
                                                        </React.Fragment>
                                                        :
                                                        <CheckedPurchaseOrder
                                                            billData={billData}
                                                            editmode={true}
                                                            viewmode={true}
                                                            handlePaginationChangeCall={handleMappedPOPaginationChange}
                                                            purchaseOrderPaginationData={mappedPOPagination}
                                                            purchaseOrderCurrentPageData={mappedPurchaseOrderCurrentPage}
                                                        />}
                                                        
                                                        </>}
                                        </div>
                                    </Segment>
                                </>
                            )
                        }}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
// }

const mapStatetoProps = state => ({
    vendorPurchaseOrderData: state.getVendorPurchaseOrderData.vendorPurchaseOrder.data,
    vendorPurchaseOrderLoading: state.getVendorPurchaseOrderData.isLoading,
    vendorPurchaseOrderPagination:state.getVendorPurchaseOrderData.vendorPurchaseOrder.pagination,
    billData: state.getBillsData.bills.data,
    billLoading: state.getBillsData.isLoading
})

export default connect( mapStatetoProps, { updateBill,getVendorPurchaseOrder, getVendorPurchaseOrderPo, getBills })(ViewBill)


